module.exports = __webpack_public_path__ + "img/appium.a4b0b264.png";